import SelectDinamico from "../../SelectDinamico";
import ConsultaEspecie from "../../../../lib/json/consultas/Especie.json"

function SelectEspecie({campoEspecie, changeEspecie, queryEspecie, disabled = false, empresaLogada, returnOriginal = false, loadDefault = true, bindItem, field, showNoFilter=false}){
    const empresaFilial = empresaLogada || localStorage.getItem('empresaFilial')
    const cConsultaDefault = ConsultaEspecie.consulta + " WHERE D_E_L_E_T_ <> '*' AND X5_TABELA = '42' AND X5_FILIAL = FILIAL(SX5) AND UPPER(X5_CHAVE + ' - ' + X5_DESCRI) LIKE (UPPER('%   %')) "
    const consulta = queryEspecie || ( loadDefault ? cConsultaDefault : '' )
    const especieValue = bindItem ? bindItem[field] : campoEspecie;

    return (
        <SelectDinamico
            label="Espécie"
            cText="X5_CHAVE.trim() + ' - ' + item.X5_DESCRI.trim()"
            cValue="X5_CHAVE.trim()"
            campoValue={especieValue}
            consulta={consulta}
            tabela={ConsultaEspecie.tabelas}
            isMultiplo={false}
            showNoFilter={showNoFilter}
            EmpresaLogada={empresaFilial}
            onchange={(e) => changeEspecie(e)}
            returnOrigem={returnOriginal}
            bindItem={bindItem}
            field={field}
            disabled={disabled}
        />
    )
}

export default SelectEspecie;